import { Actor, Sound } from "excalibur";

export class SongPlayer extends Actor {
    private stopped = false;

    constructor(private intro: Sound, private loop: Sound) {
        super();
    }

    public stop() {
        this.stopped = true;

        this.intro.stop();
        this.loop.stop();
    }

    onInitialize() {
        this.intro.play().then(() => this.loopLoop());
    }

    loopLoop() {
        if (!this.stopped) {
            this.loop.loop = true;
            this.loop.duration = 50000000;
            this.loop.play();
        }
    }
}